import axiosClient from '../util/request';
import { AdmissionData } from '../../interfaces/AdmissionData';

const admissionRepository = {
  sendAdmission: async (formData : object) => {
    return axiosClient.post('/v1/admissions', JSON.stringify(formData), {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  getAdmissionData: async () => axiosClient.get<AdmissionData>('/v1/admissions/my-data'),
};

export default admissionRepository;